import dot from "dot-object";
import qs from "qs";
import ApiClient from "./ApiClient.ts";

const attributes = {};

export const setCustomAttribute = (name, value) => {
  attributes[name] = value;
};

export const debug = (message, customAttributes = {}) => {
  sendLog("DEBUG", message, customAttributes);
};

export const info = (message, customAttributes = {}) => {
  sendLog("INFO", message, customAttributes);
};

export const error = (message, customAttributes = {}) => {
  sendLog("ERROR", message, customAttributes);
};

const sendLog = (level, message, customAttributes) => {
  const body = {
    message,
    ...dot.dot({
      attributes: {
        ...attributes,
        ...customAttributes,
      },
    }),
  };
  const urlFormData = qs.stringify(body);
  return ApiClient()
    .post("debug", urlFormData, {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    })
    .then((response) => response.data);
};
